export default "__VITE_ASSET__D9k8_P4S__"